export enum AssetType {
  Solar = 'Solar',
  Wind = 'Wind',
  Generator = 'Generator',
  EVChargingStation = 'EV Charging Station',
  StreetLight = 'Street Light',
  PublicAreaLighting = 'Public Area Lighting (Parking Lot, Pathway)',
  BatteryEnergyStorageSystem = 'Battery Energy Storage System (BESS)',
  MicroMobilityChargingDock = 'Micro-Mobility Charging Dock (e-bikes, e-scooters)',
  CombinedHeatAndPower = 'CHP (Combined Heat and Power)',
}
